import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';
import './Admin.css';

export default function Configuracoes() {
  const [config, setConfig] = useState({ empresa_nome: '', empresa_logo_url: null });
  const [salvando, setSalvando] = useState(false);
  const logoRef = useRef(null);

  useEffect(() => {
    api.get('/config').then(({ data }) => setConfig(data));
  }, []);

  const salvar = async () => {
    setSalvando(true);
    try {
      const { data } = await api.put('/config', { empresa_nome: config.empresa_nome });
      setConfig(data);
      toast.success('Configurações salvas!');
      // Atualizar localStorage para o Layout refletir imediatamente
      localStorage.setItem('empresa_config', JSON.stringify(data));
      window.dispatchEvent(new Event('empresa_config_updated'));
    } catch {
      toast.error('Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  const uploadLogo = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append('logo', file);
    try {
      const { data } = await api.post('/config/logo', form);
      setConfig(c => ({ ...c, empresa_logo_url: data.url }));
      localStorage.setItem('empresa_config', JSON.stringify({ ...config, empresa_logo_url: data.url }));
      window.dispatchEvent(new Event('empresa_config_updated'));
      toast.success('Logo atualizado!');
    } catch {
      toast.error('Erro ao enviar logo');
    }
    e.target.value = '';
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1>Configurações da Empresa</h1>
          <p>Personalize o nome e a identidade visual do sistema</p>
        </div>
      </div>

      <div style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 24, maxWidth: 480 }}>
        {/* Preview */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius)', marginBottom: 20, border: '1px solid var(--border)' }}>
          {config.empresa_logo_url
            ? <img src={config.empresa_logo_url} alt="Logo" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain' }} />
            : <div style={{ width: 40, height: 40, background: '#1D9E75', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>💬</div>
          }
          <div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>{config.empresa_nome || 'Nome da empresa'}</div>
            <div style={{ fontSize: 12, color: 'var(--texto-sec)' }}>Central de Atendimento</div>
          </div>
        </div>

        <div className="form-section" style={{ padding: 0 }}>
          <div className="field" style={{ marginBottom: 16 }}>
            <label>Nome da empresa</label>
            <input
              value={config.empresa_nome || ''}
              onChange={e => setConfig(c => ({ ...c, empresa_nome: e.target.value }))}
              placeholder="Ex: Lojas Presidente"
            />
          </div>

          <div className="field" style={{ marginBottom: 20 }}>
            <label>Logo da empresa</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6 }}>
              {config.empresa_logo_url
                ? <img src={config.empresa_logo_url} alt="Logo atual" style={{ width: 56, height: 56, borderRadius: 8, objectFit: 'contain', border: '1px solid var(--border)' }} />
                : <div style={{ width: 56, height: 56, borderRadius: 8, background: 'var(--bg-elevated)', border: '1px dashed var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🖼️</div>
              }
              <div>
                <button className="btn-secondary" onClick={() => logoRef.current?.click()} style={{ fontSize: 12 }}>
                  {config.empresa_logo_url ? '🔄 Trocar logo' : '📤 Enviar logo'}
                </button>
                <div style={{ fontSize: 11, color: 'var(--texto-ter)', marginTop: 4 }}>PNG, JPG ou SVG. Recomendado: 200×200px</div>
              </div>
              <input ref={logoRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadLogo} />
            </div>
          </div>

          <button className="btn-primary" onClick={salvar} disabled={salvando} style={{ width: '100%' }}>
            {salvando ? 'Salvando...' : 'Salvar configurações'}
          </button>
        </div>
      </div>
    </div>
  );
}
